import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("community");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ name, email, password, role });
      toast.success("Welcome to Cake Society!");
      nav("/dashboard");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="register-page" className="pt-32 pb-24 min-h-screen fade-in">
      <div className="max-w-md mx-auto px-6">
        <h1 className="font-serif text-5xl text-stone-900">Join us.</h1>
        <p className="mt-2 text-stone-600">Create an account to book classes or rent the studio.</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Your name</label>
            <input
              data-testid="register-name" required
              value={name} onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Email</label>
            <input
              data-testid="register-email" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Password (min 6 chars)</label>
            <input
              data-testid="register-password" type="password" required minLength={6}
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">I am a…</label>
            <div className="grid grid-cols-2 gap-2">
              {[
                { v: "community", l: "Cake lover" },
                { v: "creator", l: "Creator" },
              ].map((o) => (
                <button
                  key={o.v} type="button"
                  data-testid={`role-${o.v}`}
                  onClick={() => setRole(o.v)}
                  className={`px-4 py-3 rounded-xl border text-sm transition-all ${
                    role === o.v
                      ? "bg-[#121212] text-white border-[#121212]"
                      : "bg-white text-stone-700 border-stone-200 hover:border-[#121212]"
                  }`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
          <button
            data-testid="register-submit"
            disabled={busy}
            className="w-full px-6 py-4 bg-[#121212] text-[#F2E9D8] hover:bg-black text-xs tracking-[0.25em] uppercase font-bold disabled:opacity-40 transition-all"
          >
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-stone-600 text-center">
          Already have an account? <Link to="/login" className="text-[#121212] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
